import React, { useEffect, useState } from "react";
import classNames from "classnames";
import { API, Auth } from "aws-amplify";
import ReactExport from "react-data-export";
import { differenceInDays, format } from "date-fns";
import _ from "lodash";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

function ReportBad({ min, max, selectToday }) {
  const [loading, setLoadingExportContract] = useState(false);
  const [count, setCountContract] = useState(0);
  const [dataReport, setDataReport] = useState([]);
  const [isClick, setIsClick] = useState(false);

  useEffect(() => {
    if (isClick) {
      const getExportId = document.getElementById("export-excel-report-bad");
      getExportId.click();
    }
  }, [isClick, dataReport]);

  const styleColumnContract = {
    font: { sz: 16, name: "Cordia New" },
    alignment: { vertical: "center", horizontal: "center" },
    borders: {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    },
    fill: { fgColor: { rgb: "dbdbdb" } },
  };

  const getLastItem = (lastItem) => {
    let lastItemStr = "";
    if (lastItem) {
      const lastItemKeys = Object.keys(lastItem);
      lastItemKeys.forEach((key) => {
        lastItemStr += `${key}=${lastItem[key]}&`;
      });
    }
    return lastItemStr;
  };

  const onClickExportExcelAllBad = async () => {
    try {
      setLoadingExportContract(true);
      let lastItem = null;
      let datas = {};
      let count = 0;
      let allData = { Items: [] };
      do {
        datas = await API.get("MoneyHubAdmin", "/loan/reportGood", {
          queryStringParameters: {
            min_created: min,
            max_created: max,
            SELECT_ALL: true,
            ExclusiveStartKey: getLastItem(lastItem),
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        });

        lastItem = datas?.lastItem;
        count += datas?.count;
        allData.Items = [...allData.Items, ...datas.Items];
        setCountContract(count);
      } while (lastItem);

      const parseData = allData.Items.map((item) => {
        const DPD = differenceInDays(new Date(), new Date(item.overdue_date));

        if (DPD > 0) {
          return {
            ...item,
            DPD: differenceInDays(new Date(), new Date(item.overdue_date)),
          };
        }
        return null;
      }).filter((item) => item);

      setDataReport([...parseData]);
      setLoadingExportContract(false);
      setCountContract(parseData.length);
      setIsClick(true);
    } catch (error) {
      console.log("ERROR", error);
    }
  };

  const style = {
    font: { sz: 16, name: "Cordia New" },
    alignment: { vertical: "center", horizontal: "center" },
    // border: borderColumn,
  };

  const createDataWithStyleContract = (data = []) => {
    var result = [];
    const borders = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };

    const style = {
      font: { sz: 14, name: "Cordia New" },
      border: borders,
      alignment: { vertical: "center", horizontal: "center" },
    };

    for (let i = 0; i < data.length; i++) {
      if (i === data.length - 1) {
        delete style.border;
      }
      result.push([
        {
          value: data[i]?.loan_kbank_id,
          style,
        },
        {
          value: data[i]?.fullname || "",
          style,
        },
        {
          value: data[i]?.DPD || "",
          style,
        },
      ]);
    }
    return result;
  };

  const multiDataSet = [
    {
      columns: [
        {
          title: "Reference",
          width: { wch: 10 },
          style: styleColumnContract,
        },
        {
          title: "Name",
          width: { wch: 36 },
          style: styleColumnContract,
        },
        {
          title: "DPD",
          width: { wch: 12 },
          style: styleColumnContract,
        },
      ],
      data: createDataWithStyleContract(dataReport),
    },
  ];

  return (
    <div>
      <ExcelFile
        filename={`REPORT_BAD_${format(new Date(selectToday), "yyyy-MM-dd")}`}
        element={<button id="export-excel-report-bad" hidden></button>}
      >
        <ExcelSheet dataSet={multiDataSet} name="Report Bad"></ExcelSheet>
      </ExcelFile>
      <button
        disabled={loading}
        className={classNames(
          "p-4  text-white mt-2 flex flex-row rounded-lg items-center w-full",
          {
            "bg-green-500": !loading,
            "bg-gray-400": loading,
          }
        )}
        onClick={onClickExportExcelAllBad}
      >
        {loading && (
          <svg
            className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx={12}
              cy={12}
              r={10}
              stroke="currentColor"
              strokeWidth={4}
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            />
          </svg>
        )}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6 mr-2"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 13h6M3 17V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
          />
        </svg>
        {count > 0 && `(${count})`} Report Bad
      </button>
    </div>
  );
}

export default ReportBad;
